import angular from "angular";

angular
    .module('app')
    .component('taskAnswerForm', {
        template: require('./task-answer-form.html'),
        controller: ['$http', 'ErrorResponseParser', 'Notifier', '$uibModal', '$window', controller],
        bindings: {
            resolve: '<',
            close: '&',
            dismiss: '&'
        }
    });

function controller($http, ErrorResponseParser, Notifier, $uibModal, $window) {

    let $ctrl = this;

    $ctrl.answer = null;

    $ctrl.status = null;

    $ctrl.$onInit = function () {
        $ctrl.answer = $ctrl.resolve.answer;
        if ($ctrl.answer) {
            $ctrl.status = $ctrl.answer.status;
            $ctrl.methodist_answer = $ctrl.answer.methodist_answer;
        }
    };

    $ctrl.submit = function () {

        $ctrl.loading = true;

        let params = {
            methodist_answer: $ctrl.methodist_answer,
            status: $ctrl.status,
        };

        $http.post(`/admin/answers/${$ctrl.answer.id}/set-reply`, params).then(
            function (response) {
                Notifier.success('Успешно обновлена', 2);
                $ctrl.close({$value: params});

            },
            function (error) {
                $ctrl.loading = false;
                $ctrl.status = 'open';
                if (error.status == 422) {
                    $ctrl.validationErrors = error.data.errors;
                    Notifier.error('Заполните поле "Ответ методиста"', 2);
                } else {
                    Notifier.error('Произошла ошибка с текстом:' + error.data.message, 2);
                }
            }
        );

    }

    $ctrl.openImage = function (file) {
        window.open(file.url);
    };
}
